import getCDNURL from '@pickleballinc/ui/components/global/utils/getCDNURL';
import Link from 'next/link';

import { PTLSvgSmallIcon } from '@/components/atoms';
import { ModalWrapper } from '@/components/organisms';
import { TeamRecord } from '@/entities/Player';

interface PlayerTeamsModalProps {
	teamLeagueUuid?: string;
	title: string;
	onClose: () => void;
	listOfTeams: TeamRecord[];
}

export const PlayerTeamsModal = ({ teamLeagueUuid, title, onClose, listOfTeams = [] }: PlayerTeamsModalProps) => {
	return (
		<ModalWrapper title={title} onClose={onClose} className="z-50 max-w-[524px] !gap-0 p-6">
			<p className="my-4 text-sm font-medium leading-5 text-gray-700">You can click on the team name to go to the team page.</p>

			<hr className="my-4" />

			<div className="z-50 flex flex-col gap-4">
				{listOfTeams.map((item) => (
					<div key={item.teamUuid} className="flex cursor-pointer items-center gap-2">
						{item.logo?.url ? (
							<img src={getCDNURL(item.logo.url, 120, 60)} alt="Icon" className="flex w-16 h-8 items-center rounded-sm object-cover" />
						) : (
							<div className="flex w-16 h-8 items-center rounded-full object-cover justify-center">
								<PTLSvgSmallIcon />
							</div>
						)}
						<Link
							prefetch={false}
							href={{
								pathname: `/team-leagues/${teamLeagueUuid}/team-stats/${item.currentSeasonUuid}/${item.teamUuid}`,
								query: { from: 'players' }
							}}
						>
							<span className="text-sm font-semibold leading-5 text-darkorange-400">{item.teamTitle}</span>
						</Link>
					</div>
				))}
			</div>
		</ModalWrapper>
	);
};
